import React from 'react';
import { RegisterForm } from '../components/Forms/RegisterForm';
import { FullScreenBackgroundImgSlider } from '../components/Slider/FullScreenBackgroundImgSlider';
import { t } from 'i18next';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Helmet } from 'react-helmet-async';

const Register: React.FC = () => {
  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
      <Helmet>
        <title>{t('create_an_account')} - Hephaestus</title>
      </Helmet>
      <div>
        <FullScreenBackgroundImgSlider />
        <div className="flex-row--reverse-800 flex-1">
          <div className="double-border-component">
            <div>
              <RegisterForm />
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Register;
